/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FileAccess,
    FileAccessFromJSON,
    FileAccessFromJSONTyped,
    FileAccessToJSON,
} from './FileAccess';
import {
    FileObjectType,
    FileObjectTypeFromJSON,
    FileObjectTypeFromJSONTyped,
    FileObjectTypeToJSON,
} from './FileObjectType';
import {
    FilePurpose,
    FilePurposeFromJSON,
    FilePurposeFromJSONTyped,
    FilePurposeToJSON,
} from './FilePurpose';
import {
    FileType,
    FileTypeFromJSON,
    FileTypeFromJSONTyped,
    FileTypeToJSON,
} from './FileType';

/**
 * 
 * @export
 * @interface FileObject
 */
export interface FileObject {
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    id: string;
    /**
     * 
     * @type {FileObjectType}
     * @memberof FileObject
     */
    object: FileObjectType;
    /**
     * 
     * @type {FilePurpose}
     * @memberof FileObject
     */
    purpose: FilePurpose;
    /**
     * 
     * @type {FileAccess}
     * @memberof FileObject
     */
    access?: FileAccess;
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    filename: string;
    /**
     * 
     * @type {FileType}
     * @memberof FileObject
     */
    filetype: FileType;
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    context: string;
    /**
     * 
     * @type {number}
     * @memberof FileObject
     */
    size: number;
    /**
     * A blurhash string using Wolt BlurHash algorithm.
     * @type {string}
     * @memberof FileObject
     */
    blurhash?: string;
    /**
     * 
     * @type {Date}
     * @memberof FileObject
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    created_by: string;
}

export function FileObjectFromJSON(json: any): FileObject {
    return FileObjectFromJSONTyped(json, false);
}

export function FileObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': FileObjectTypeFromJSON(json['object']),
        'purpose': FilePurposeFromJSON(json['purpose']),
        'access': !exists(json, 'access') ? undefined : FileAccessFromJSON(json['access']),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'filename': json['filename'],
        'filetype': FileTypeFromJSON(json['filetype']),
        'url': json['url'],
        'context': json['context'],
        'size': json['size'],
        'blurhash': !exists(json, 'blurhash') ? undefined : json['blurhash'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'created_by': json['created_by'],
    };
}

export function FileObjectToJSON(value?: FileObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': FileObjectTypeToJSON(value.object),
        'purpose': FilePurposeToJSON(value.purpose),
        'access': FileAccessToJSON(value.access),
        'title': value.title,
        'filename': value.filename,
        'filetype': FileTypeToJSON(value.filetype),
        'url': value.url,
        'context': value.context,
        'size': value.size,
        'blurhash': value.blurhash,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'created_by': value.created_by,
    };
}

